__turbopack_context__.v({
  "fields": "brCiWG_fields" + " " + __turbopack_context__.i(455038)["fields"],
  "footer": "brCiWG_footer" + " " + __turbopack_context__.i(455038)["footer"],
  "link": "brCiWG_link" + " " + __turbopack_context__.i(455038)["link"],
});
